export interface IPermission {
  id: number;
  module: string;
  feature: string;
  scope: string;
  slug: string;
  description: string;
  name?: string;
}

export interface IPermissionConfig {
  prefix?: string[];
  redirectCommand?: string[];
}
